import { useCallback } from "react";
import type { ContactInfoFormValues } from "components/forms/contact-info-section/contact-info-section.component";
import { useUpdateUserProfile } from "./use-update-user-profile.hook";

export const useUpdateContactInfo = () => {
  const { updateUserProfile, isLoading } = useUpdateUserProfile();

  const updateContactInfo = useCallback(
    async (values: ContactInfoFormValues) => {
      const phoneNumbers = [
        {
          description: "primary",
          number: values.primaryPhoneNumber,
          countryCode: 0,
        },
      ];

      if (values.mobilePhoneNumber) {
        phoneNumbers.push({
          description: "mobile",
          number: values.mobilePhoneNumber,
          countryCode: 0,
        });
      }

      await updateUserProfile({
        email: values.email,
        phone_numbers: phoneNumbers,
      } as any);
    },
    [updateUserProfile]
  );

  return { updateContactInfo, isLoading };
};
